import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Route guard: only platform super-admins may pass. Everyone else is bounced to
 * the dashboard. While entitlements are still loading we render nothing to avoid
 * a flash of the admin UI.
 */
const RequirePlatformAdmin = ({ children }) => {
  const { isPlatformAdmin, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64 text-gray-400">
        Checking access…
      </div>
    );
  }
  if (!isPlatformAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default RequirePlatformAdmin;
